import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Controller, useForm } from 'react-hook-form';
import * as _ from 'lodash';

import {
  BackButton,
  CancelButton,
  GeneralErrors,
  KebabDropdown,
  PageHeader,
} from '../../components';
import { updateReport } from '../../redux/reports/actions';
import { useConfirmAction, useReadOnly } from '../../utils/hooks';

import layout from '../../styles/layout.module.scss';
import { MiscDetailsSelect } from '../../components/inputs/MiscDetailsSelect.js';

export default function MiscDetailForm ({ currReport }) {
  const readOnly = useReadOnly();
  const history = useHistory();
  const dispatch = useDispatch();
  const confirmAction = useConfirmAction();
  const {
    handleSubmit,
    formState,
    control,
  } = useForm({ defaultValues: currReport });

  const { isSubmitted } = formState;

  const pending = useSelector((s) => s.reports.changeReportPending);
  const error = useSelector((s) => s.reports.changeReportError);
  const submitSuccess = isSubmitted && !pending && !error;

  const submit = useCallback((data) => {
    dispatch(updateReport({
      ...data,
      misc_details: _.map(
        _.get(data, 'misc_details', []),
        (b) => b.id,
      ),
      id: currReport.id,
    }));
  }, [currReport]);

  const removeDetails = useCallback(() => {
    confirmAction({
      action: 'remove',
      subjectType: 'miscellaneous details',
      subject: 'this detail',
      onConfirm: () => dispatch(updateReport({
        misc_details: [],
        id: currReport.id,
      })),
      pendingPath: 'reports.changeReportPending',
      errorPath: 'reports.changeReportError',
      onSuccess: history.goBack,

    });
  }, [currReport, confirmAction]);

  // Submit success
  useEffect(() => {
    if (submitSuccess) {
      history.goBack();
    }
  }, [submitSuccess]);

  return (
    <div className={layout.page}>
      <PageHeader
        title="Misc. Diagnosis Details"
        coverMenu
      >
        <BackButton/>
        {
          (
            !readOnly &&
            _.get(currReport, 'misc_details.length', 0) > 0
          ) && (
            <KebabDropdown right>
              <DropdownItem onClick={removeDetails}>
                <FontAwesomeIcon icon="trash" />
                Remove Misc. Details
              </DropdownItem>
            </KebabDropdown>
          )
        }
      </PageHeader>
      <div className={layout.pageContent}>
        <div className={layout.responsiveContainer}>
          {!currReport ?
            <div className="text-center">
              <Spinner />
            </div>
            :
            <Form
              className={layout.responsiveContainer}
              onSubmit={handleSubmit(submit)}
            >
              <FormGroup>
                <Label>Misc. Diagnosis Details (water quality, etc..)</Label>
                <Controller
                  as={MiscDetailsSelect}
                  name="misc_details"
                  control={control}
                  invalid={ isSubmitted && _.has(error, 'misc_details') }
                  disabled={readOnly}
                />
                <FormFeedback role="alert">
                  { _.get(error, 'misc_details') }
                </FormFeedback>
              </FormGroup>
              { isSubmitted && <GeneralErrors error={error} /> }
              {!readOnly && (
                <Button
                  color="primary"
                  disabled={pending}
                  block
                >
                  Save{' '}
                  { pending && <Spinner size="sm" /> }
                </Button>
              )}
              <CancelButton />
            </Form>
          }
        </div>
      </div>
    </div>
  );
}
